import { Part, PartProduct } from '@app/entities/Product';
import { extraAttributes } from '../../const/extraAttributes';
import { Product, ProductSpecCode, ProductSpecifications, ProductSpecs } from '../../types/productSchema';

export const attachFeatureToProduct = (product: Product, specsProduct: ProductSpecs[]): ProductSpecs[] => {
  try {
    const { part } = product;
    switch (part) {
      case Part.Tyres:
      case Part.Disks:
      case Part.TruckTires:
      case Part.Batteries:
      case Part.Oils:
      case Part.RelatedProducts:
      case PartProduct.Tyres:
      case PartProduct.Disks:
      case PartProduct.TruckTires:
      case PartProduct.Batteries:
      case PartProduct.Oils:
      case PartProduct.RelatedProducts:
        return extraAttributes.map(attribute => extraAttributesType(attribute, specsProduct, product)).filter(x => x);
      default:
        return [];
    }
  } catch (error) {
    console.log('attachFeatureToProduct :', error);
    return [];
  }
};

const extraAttributesType = (attribute: Pick<ProductSpecs, 'code' | 'title'>, specsProduct: ProductSpecs[], product: Product): ProductSpecs => {
  const model = product.model;
  const brand = product.brand;
  if (attribute.code === ProductSpecCode.SellerCode) {
    return {
      ...attribute,
      value: product?.rn,
    };
  }
  if (
    [PartProduct.Tyres, Part.Tyres, PartProduct.TruckTires, Part.TruckTires, PartProduct.Disks, Part.Disks].includes(product.part) &&
    attribute.code === ProductSpecCode.BackProduct
  ) {
    return {
      ...attribute,
      value: '14 дней',
      href: '/garantii#back',
    };
  }
  if (attribute.code === ProductSpecCode.StandardFactory) {
    return {
      ...attribute,
      value: 'Стандартная заводская',
      href: '/garantii#standard',
    };
  }
  if (attribute.code === ProductSpecCode.Size && [PartProduct.Tyres, Part.Tyres].includes(product.part)) {
    const [width, height, diameter] = [
      specsProduct.find(x => x.code === ProductSpecCode.Width),
      specsProduct.find(x => x.code === ProductSpecCode.Height),
      specsProduct.find(x => x.code === ProductSpecCode.Diameter),
    ];
    return {
      ...attribute,
      value: `${width.value}/${height.value}/${diameter.value}`,
      href: '/catalog/tyres/all_sizes/' + `${width.value}-${height.value}-${diameter.value}/`,
      meta: {
        width: width.value,
        height: height.value,
        diameter: diameter.value,
      },
    };
  }
  if (attribute.code === ProductSpecCode.Size && [PartProduct.Disks, Part.Disks].includes(product.part)) {
    const [width, diameter, pcd, et, dia] = [
      specsProduct.find(x => x.code === ProductSpecCode.DiskWidth),
      specsProduct.find(x => x.code === ProductSpecCode.DiskRadius),
      specsProduct.find(x => x.code === ProductSpecCode.DiskUnitedPcd),
      specsProduct.find(x => x.code === ProductSpecCode.DiskEt),
      specsProduct.find(x => x.code === ProductSpecCode.DiskDia),
    ];
    return {
      ...attribute,
      value: `${width.value}x${diameter.value}` + ' ' + `${pcd.value} ET${et.value} Dia${dia.value}`,
      href:
        '/catalog/filter/discs/?display=block' +
        `&${ProductSpecifications.DiscsWidth}=${width.value}` +
        `&${ProductSpecifications.DiscsDiameter}=${diameter.value}` +
        `&${ProductSpecifications.DiscsPcd}=${pcd.value}` +
        `&${ProductSpecifications.DiscsEt}=${et.value}` +
        `&${ProductSpecifications.DiscsDia}=${dia.value}`,
    };
  }
  if (attribute.code === ProductSpecCode.Size && [PartProduct.TruckTires, Part.TruckTires].includes(product.part)) {
    const [width, height, diameter] = [
      specsProduct.find(x => x.code === ProductSpecCode.TruckTyresWidth),
      specsProduct.find(x => x.code === ProductSpecCode.TruckTyresHeight),
      specsProduct.find(x => x.code === ProductSpecCode.TruckTyresDiam),
    ];
    return {
      ...attribute,
      value: `${width.value}/${height.value}/${diameter.value}`,
      href:
        '/catalog/filter/trucktyres/?display=block' +
        `&${ProductSpecifications.TruckTyresWidth}=${width.value}` +
        `&${ProductSpecifications.TruckTyresProfile}=${height.value}` +
        `&${ProductSpecifications.TruckTyresDiameter}=${diameter.value}`,
    };
  }
  if (attribute.code === ProductSpecCode.Size && [PartProduct.Batteries, Part.Batteries].includes(product.part)) {
    const [width, height, diameter] = [
      specsProduct.find(x => x.code === ProductSpecCode.AkbWidth),
      specsProduct.find(x => x.code === ProductSpecCode.AkbHeight),
      specsProduct.find(x => x.code === ProductSpecCode.AkbLength),
    ];
    return {
      ...attribute,
      value: `${width.value}/${height.value}/${diameter.value}`,
      href: '/catalog/accumulators/all_sizes/' + `${width.value}x${height.value}x${diameter.value}/`,
    };
  }
  if (attribute.code === ProductSpecCode.Brand && brand) {
    return {
      ...attribute,
      value: brand.name,
      href: brand.href,
    };
  }
  if (attribute.code === ProductSpecCode.Model && model) {
    return {
      ...attribute,
      value: model.name,
      href: model.href,
    };
  }
  if ([PartProduct.Tyres, Part.Tyres].includes(product.part) && attribute.code === ProductSpecCode.ExtendedWarranty) {
    return {
      ...attribute,
      value: '',
      href: '',
      loading: true,
    };
  }

  return null;
};
